module.exports = function() {
  return new Worker(__webpack_public_path__ + "formula.worker.b48a32ce.worker.js");
};